module.exports = __webpack_public_path__ + "static/media/logo-ubiflow@3x.6649b1cf.png";